var cov_syrqdcbf = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tooltip/index.ts",
      hash = "f630170004a50c65f35f7faa8477128a40f28b81",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Tooltip/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 43
        }
      },
      "1": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 39
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import create from './Container';
import * as events from './events';
var Tooltip = (cov_syrqdcbf.s[0]++, create(events));
cov_syrqdcbf.s[1]++;
Tooltip.displayName = 'ShineoutTooltip';
export default Tooltip;